import { Box } from '@material-ui/core'
import { Advantages } from '../components/home/advantages'
import langs from '../langs'
import React from 'react'
import SEO from '../components/seo'
import Header from '../layout/header'

const BlinkFrontend = () => {
  return (
    <>
      <SEO title={langs.home.blinkFrontend.title} />

      <Header />

      <Box className={`section sectionBg`}>
        <Box className={`sectionInner`} style={{ maxWidth: '800px' }}>
          <h1>{langs.home.blinkFrontend.title}</h1>
          <h2>{langs.home.blinkFrontend.subtitle}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: langs.home.blinkFrontend.description,
            }}
          />
        </Box>
      </Box>

      <Box className={`section sectionBg`}>
        <Box className={`sectionInner`}>
          <Advantages
            light={true}
            title={langs.home.advantages.title}
            advantages={langs.home.advantages.advantages}
          />
        </Box>
      </Box>

      <Box className={`section`}>
        <Box className={`sectionInner`}>
          <Advantages
            title={langs.home.advantagesBlinkcart.title}
            advantages={langs.home.advantagesBlinkcart.advantages}
          />
        </Box>
      </Box>
    </>
  )
}

export default BlinkFrontend
